/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Sunny Raj",
  title: "Hi all, I'm Sunny",
  // subTitle: emoji(
  //   "Software Developer 🚀 || Open Source enthusiast 👨‍💻 || JISCE Kalyani 🎓"
  // ),
  subTitle:
    "Software Developer 👨‍💻 || Open Source enthusiast 🚀 || Competitive Programmer 🎯",
  resumeLink: "https://sraj1333sr.wixsite.com/resume-site", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/SR-Sunny-Raj",
  linkedin: "https://linkedin.com/in/sunnyraj2424",
  gmail: "sraj1333.sr@gmail.com",
  gitlab: "https://gitlab.com/SR-Sunny-Raj",
  // facebook: "#",
  // medium: "#",
  stackoverflow: "https://stackoverflow.com/users/16091237/sunny-raj",
  // Instagram, Twitter and Kaggle are also supported in the links!
  instagram: "https://instagram.com/_suuunnnyyy",
  twitter: "https://twitter.com/@sunnyrajsunny3",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "TRYING TO IMPROVE THE WORLD WITH TECHNOLOGY",
  skills: [
    // emoji(
    //   "⚡ Solves real world problems to make our day to day life easier by creating utility tools"
    // ),
    // emoji(
    //   "⚡ Learn Data Structures and Algorithms and also work with Competitive Programming!"
    // ),
    // emoji("⚡ Active open-source contributor")
    "⚡ Solves real world problems to make our day to day life easier by creating utility tools",
    "⚡ Learn Data Structures and Algorithms and also work with Competitive Programming!",
    "⚡ Active open-source contributor"
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "React JS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "NodeJs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "C/C++",
      fontAwesomeClassname: "far fa-copyright"
    },
    {
      skillName: "SQL-Database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "HTML-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "JIS College Of Engineering, Kalyani",
      logo: require("./assets/images/JIS_College_of_Engineering_Logo.png"),
      subHeader: "Bachelor Of Technology in Computer Science",
      duration: "June 2019 - June 2023",
      desc: "Learning Data Structures, Operating Systems, Computer Architecture, DBMS and Discrete Mathematics",
      descBullets: ["DGPA :- 9.10/10"]
    },
    {
      schoolName: "D.A.V Public School, Cantt. Area, Gaya",
      logo: require("./assets/images/dav_logo_updated.jpg"),
      subHeader: "Higher Secondary, (PCM)",
      duration: "June 2016 - May 2018",
      // desc: "",
      descBullets: ["Boards -: 69.8%"]
    },
    {
      schoolName: "Jai Hind Public School, Vigyan Nagar, Bodhgaya",
      logo: require("./assets/images/jai-hind-public-school-logo.jpeg"),
      subHeader: "Secondary",
      duration: "March 2016",
      // desc: "",
      descBullets: ["Grade -: 9.8 CGPA"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend Development (HTML-CSS-JS, React JS, Next JS)",
      progressPercentage: "85%"
    },
    {
      Stack: "Java", //Insert stack or technology you have experience in
      progressPercentage: "75%" //Insert relative proficiency in percentage
    },
    {
      Stack: "C/C++",
      progressPercentage: "70%"
    },
    {
      Stack: "Databases (SQL, MongoDB)",
      progressPercentage: "65%"
    },
    {
      Stack: "Competitive Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Associate Software Engineer",
      company: "Accenture Solutions Pvt Ltd",
      companylogo: require("./assets/images/acc_logo.jpeg"),
      date: "July 2023 – Present",
      desc: "Frontend Developer",
      descBullets: [
        "Working as a UI Developer on technologies like React JS, Next JS, scss, etc."
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Persistent Systems",
      companylogo: require("./assets/images/psl_logo2.png"),
      date: "Jan 2023 – June 2023",
      desc: "Career Compass Program",
      descBullets: [
        "Learned and worked on Java, J2EE, Spring Framework, Spring Boot, JDBC, Maven, Javascript"
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "Persistent Systems",
      companylogo: require("./assets/images/psl_logo2.png"),
      date: "May 2022 – July 2022",
      desc: "Martian Program",
      descBullets: [
        "Learned J2EE, Data Structures, Operating Systems, DBMS and CN"
      ]
    },
    {
      role: "Web Development and Designing Intern",
      company: "The Sparks Foundation",
      companylogo: require("./assets/images/the_sparks_foundation_logo.png"),
      date: "August 2021 – September 2021",
      desc: "Graduate Rotational Internship Program (GRIP)",
      descBullets: [
        "Completed a Web development Project",
        "Improved connections in the Industry"
      ]
    },
    {
      role: "Software Engineer Intern",
      company: "HighRadius Corporation",
      companylogo: require("./assets/images/hrc_logo.png"),
      date: "January 2022 – April 2022",
      desc: "Product Essentials Program",
      descBullets: [
        "Developed a deep understanding of all aspects of product development.",
        "Built and deployed an AI Enabled Fintech B2B Cloud Application."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/tsf_fp.png"),
      projectName: "Banking System WebApp",
      projectDesc:
        "A Banking website which demonstrate various types of actions like money transfer,deposit along with new account creation",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://banking-system-mp8o.onrender.com"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/weather_fp.png"),
      projectName: "Weather WebApp",
      projectDesc:
        "A Weather Dashboard to update you with the weather of any city in the world!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://sr-sunny-raj.github.io/Weather_WebApp/"
        }
      ]
    },
    {
      image: require("./assets/images/todo_fp.png"),
      projectName: "To-Do WebApp",
      projectDesc:
        "A To-Do list WebApp to remind you of the tasks that need to be done",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://to-do-list-vy1c.onrender.com"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  // title: emoji("Achievements And Certifications 🏆 "),
  title: "Achievements And Certifications 🏆 ",
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "TCS CodeVita Season 10 Qualifier",
      subtitle: "Secured global rank of 1054 in TCS CodeVita Season 10",
      image: require("./assets/images/tcs_cv_fp.png"),
      imageAlt: "tcs-cv",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1C89t-nE0YObCpQPjmjrkeJRhgfxgRjZc/view?usp=share_link"
        }
      ]
    },
    {
      title: "Sparkling Star Award",
      subtitle:
        "Received Sparkling Star Award for extraordianry performance in the month of July-August 2024",
      image: require("./assets/images/acc_sparkling_star.png"),
      imageAlt: "acc_sparkling_star_award",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1YiE_nTxfV6aBsP3D97VGCOO1eHtdhAmn/view?usp=sharing"
        }
      ]
    },
    {
      title: "Certificate Of Appreciation",
      subtitle: "Ranked 3rd in the top 3 during 2nd year of B.Tech",
      image: require("./assets/images/coa_pic.png"),
      imageAlt: "3rd",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1NXKPu5FImu0FvhW_WpBeAhvp59711eC8/view?usp=share_link"
        }
      ]
    },
    {
      title: "Microsoft MS-900 Certification",
      subtitle: "Microsoft 365 Certified: Fundamentals",
      image: require("./assets/images/MS900_MS_Certificate.png"),
      imageAlt: "microsoft MS-900",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1Iql7PaV6104gCzM_twNjEHVQIuZVrOMs/view?usp=sharing"
        }
      ]
    },
    {
      title: "Microsoft AI-900 Certification",
      subtitle: "Microsoft Certified: Azure AI Fundamentals",
      image: require("./assets/images/AI900_MS_Certificate.png"),
      imageAlt: "microsoft AI-900",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1gmFPSZ06koVFKGjWWTzcgN94zqa0ByFq/view?usp=sharing"
        }
      ]
    },
    {
      title: "Microsoft AZ-500 Certification",
      subtitle: "Microsoft Certified: Azure Security Engineer Associate",
      image: require("./assets/images/AZ500_MS_Certificate.png"),
      imageAlt: "microsoft AZ-500",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1JJgp03WGhvPQg30aKsy41k3jQP9sTLO7/view?usp=sharing"
        }
      ]
    },
    {
      title: "Microsoft SC-900 Certification",
      subtitle:
        "Microsoft Certified: Security, Compliance, and Identity Fundamentals",
      image: require("./assets/images/Microsoft_SC-900.png"),
      imageAlt: "microsoft SC-900",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/18Q1mZq8K5K-TNe8v_c8PHVKdkMxvUyEq/view?usp=sharing"
        }
      ]
    },
    {
      title: "Microsoft AZ-900 Certification",
      subtitle: "Microsoft Certified: Azure Fundamentals",
      image: require("./assets/images/Microsoft_AZ-900_Certificate.png"),
      imageAlt: "microsoft AZ-900",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1jcMtsvMy2CNNICl3TQeCO_Nl9ct4YNrx/view?usp=sharing"
        }
      ]
    },
    {
      title: "Accenture Stream Training Certificate",
      subtitle: "Successfully Completed the Stream Training of Accenture",
      image: require("./assets/images/Accenture_Stream_Training.png"),
      imageAlt: "acc-stream",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1aTGn8CdqQ8upZAyA2jSi_3pLEomFuOox/view?usp=sharing"
        }
      ]
    },
    {
      title: "Persistent Systems Martian Internship",
      subtitle:
        "Successful completion of Persistent Systems Martian Internship Program 2022",
      image: require("./assets/images/psl_martian.png"),
      imageAlt: "psl-martian",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1qpSxuFgIyTVOHF5CAIlAgk1SUJXP3a8Q/view?usp=sharing"
        }
      ]
    },
    {
      title: "Persistent Systems Career Compass Internship",
      subtitle:
        "Successful completion of Persistent Systems Career Compass Program",
      image: require("./assets/images/psl_career_compass.png"),
      imageAlt: "psl-career-compass",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1dpG_2HGKVchuVw4sedtp3YJUJa4e2hU-/view?usp=sharing"
        }
      ]
    },
    {
      title: "HighRadius Corporation Internship",
      subtitle: "Product Essentials Program",
      image: require("./assets/images/hrc_certificate.png"),
      imageAlt: "hrc-internship",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1Dxmpm183h03TWE8EWSJzlozG1bc4-KAG/view?usp=sharing"
        }
      ]
    },
    {
      title: "The Sparks Foundation Internship Certificate",
      subtitle: "Graduate Rotational Internship Program (GRIP)",
      image: require("./assets/images/sparks_foundation_certificate.png"),
      imageAlt: "tsf-certificate",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1vxICg7c4L4Wz9_VnTszcHSPhfwZD227H/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Sometimes I like to write and share some things that I've learned.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "#",
      title: "Docker & GitHub Actions",
      description:
        "How to use Docker and show with GitHub Actions, in effect, you don't need a complex architecture"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  // subtitle: emoji(
  //   "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  // ),
  subtitle: "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅",

  talks: [
    {
      title: "#",
      subtitle: "#",
      slides_url: "#",
      event_url: "#"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["#"],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  // title: emoji("Contact Me ☎️"),
  title: "Contact Me ☎️",
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-7050776192",
  email_address: "sraj1333.sr@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};

//Steps to follow while deploying -:
// npm update --force
// 1) npm start
// npm run build

// Linking Portfolio to GitHub -:
// - Sunny's Portfolio
//   - node_modules
//   - public
//   - src
//   - .env         <-- create it here
//   - env.example  <-- this is the base file
//   - .gitignore
//   - package-lock.json
//   - package.json

// Inside the .env file, add key REACT_APP_GITHUB_TOKEN and assign your GitHub token like this,
// also add your username as GITHUB_USERNAME
// .env
// REACT_APP_GITHUB_TOKEN = "YOUR GITHUB TOKEN HERE"
// GITHUB_USERNAME = "YOUR GITHUB USERNAME"
// USE_GITHUB_DATA = "true"

// Set showGithubProfile to true or false to show Contact Profile using GitHub, defaults to false.
